  document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const productGrids = document.querySelectorAll('.shop-by-need__products-grid');

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const dataKey = this.getAttribute('data-key');

        // Remove active state from all buttons
        tabButtons.forEach(btn => {
          btn.classList.remove('active-button');
          btn.setAttribute('aria-selected', 'false');
        });

        // Add active state to clicked button
        this.classList.add('active-button');
        this.setAttribute('aria-selected', 'true');

        // Hide all grids
        productGrids.forEach(grid => {
          grid.classList.add('hidden');
        });

        // Show matching grid
        const activeGrid = document.querySelector(`[data-key-wrapper="${dataKey}"]`);
        if (activeGrid) {
          activeGrid.classList.remove('hidden');
        }
      });
    });
  });